/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonDailyTrxInfo } from './BabylonDailyTrxInfo';

export type BabylonHomeTrxListInfo = {
    TRXHTP: BabylonHomeTrxListInfo.TRXHTP;
    TRXTP: BabylonHomeTrxListInfo.TRXTP;
    DAVGTRXC: string;
    DTRXLIST: Array<BabylonDailyTrxInfo>;
};

export namespace BabylonHomeTrxListInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
        CLAIM = 'CLAIM',
        DEPOSIT = 'DEPOSIT',
        USER = 'USER',
        AVG_GAS_PRICE = 'AVG_GAS_PRICE',
    }


}

